// extracted by mini-css-extract-plugin
export default {"wrapper":"wallet_wrapper__7O3rU","formContainer":"wallet_formContainer__ETkKs","formBox":"wallet_formBox__F3Y61"};